import React from 'react'
import { useState } from 'react'
import Eateries from './Eateries'

const Search = ({ onSearch, eateries, getData }) => {

    const [name, setName] = useState('')

    const onSubmit = (e) => {
        e.preventDefault()

        if (!name) {
            alert('Please enter a restaurant')
            return
        }

        //onSearch({ name })
        getData({ name })

        setName('')
    }

  return (
    <>
    <form className='form-group' onSubmit={onSubmit}>
        <input type="text" placeholder='Enter restaurant' value={name} onChange={(e) => setName(e.target.value)}/>
        <input type="submit" value="Search"/>
    </form>    

    <Eateries key={eateries.id} eateries={eateries} />
    
    </>

  )
}

export default Search